import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { MobileNav } from "./MobileNav";
import { Sidebar } from "./Sidebar";

export function AppLayout() {
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-transparent text-[color:var(--text)]">
      <Header onMenu={() => setOpen(true)} />
      <div className="flex min-h-[calc(100vh-4rem)]">
        {open ? (
          <div className="fixed inset-0 z-40 lg:hidden">
            <button
              type="button"
              aria-label="ナビゲーションを閉じる"
              className="absolute inset-0 bg-black/35"
              onClick={() => setOpen(false)}
            />
            <div className="relative h-full">
              <Sidebar mobile onNavigate={() => setOpen(false)} />
            </div>
          </div>
        ) : null}
        <div className="flex min-w-0 flex-1 flex-col">
          <main id="main-content" className="mx-auto w-full max-w-7xl flex-1 px-4 pb-28 pt-4 sm:px-6 lg:px-8">
            <Outlet />
          </main>
        </div>
      </div>
      <MobileNav />
    </div>
  );
}
